import { useState } from "react";

const faqs = [
  {
    q: "如何按画风或主题快速找到想要的图集？",
    a: "您可以通过首页的「画风鉴赏」板块，或使用画廊区的分类筛选功能，按原画、插画、画风、壁纸等维度浏览。每个分类下还配有清晰的标签，方便您精准定位感兴趣的作品。",
  },
  {
    q: "网站上的高清壁纸可以免费下载吗？",
    a: "琉璃神社以鉴赏和收藏为主，绝大多数壁纸与图集均可免费在线浏览和收藏。具体作品的授权与使用规则，请以作品卡片上的说明为准，并尊重创作者的版权。",
  },
  {
    q: "画廊作品会定期更新吗？",
    a: "会的。我们每周都会精选并上新一批优质图集与画作，同时根据同好的反馈持续扩充画风分类，让您每次来访都有新的视觉惊喜。",
  },
  {
    q: "遇到无法显示的图片或页面问题该怎么办？",
    a: "您可以刷新页面或更换网络后重试。若问题依然存在，欢迎通过下方「联系我们」表单反馈，我们会第一时间排查并修复，确保您的浏览体验顺畅。",
  },
  {
    q: "如何向平台推荐或投稿自己的作品？",
    a: "我们非常欢迎原创画师的投稿。您可以通过联系表单留下作品链接与简介，编辑团队审核后会将符合标准的优质作品收录进对应的画廊分类。",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">FAQ</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">常见问题</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            关于图集浏览、壁纸下载与投稿合作的常见疑问，都在这里为您解答。
          </p>
        </div>

        <div className="mt-9 space-y-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border transition ${
                  open ? "border-primary-300 bg-background-100" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm transition ${
                      open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={`ri-arrow-down-s-line transition-transform ${open ? "rotate-180" : ""}`}></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}